export interface CountryCode {
  name: string;
  nameEn: string;
  code: string; // ISO 3166-1 alpha-2
  dialCode: string; // Phone code with +
  flag: string; // Emoji flag
}

export const countryCodes: CountryCode[] = [
  { name: 'Türkiye', nameEn: 'Turkey', code: 'TR', dialCode: '+90', flag: '🇹🇷' },
  { name: 'Amerika Birleşik Devletleri', nameEn: 'United States', code: 'US', dialCode: '+1', flag: '🇺🇸' },
  { name: 'Birleşik Krallık', nameEn: 'United Kingdom', code: 'GB', dialCode: '+44', flag: '🇬🇧' },
  { name: 'Almanya', nameEn: 'Germany', code: 'DE', dialCode: '+49', flag: '🇩🇪' },
  { name: 'Fransa', nameEn: 'France', code: 'FR', dialCode: '+33', flag: '🇫🇷' },
  { name: 'İtalya', nameEn: 'Italy', code: 'IT', dialCode: '+39', flag: '🇮🇹' },
  { name: 'İspanya', nameEn: 'Spain', code: 'ES', dialCode: '+34', flag: '🇪🇸' },
  { name: 'Hollanda', nameEn: 'Netherlands', code: 'NL', dialCode: '+31', flag: '🇳🇱' },
  { name: 'Belçika', nameEn: 'Belgium', code: 'BE', dialCode: '+32', flag: '🇧🇪' },
  { name: 'İsviçre', nameEn: 'Switzerland', code: 'CH', dialCode: '+41', flag: '🇨🇭' },
  { name: 'Avusturya', nameEn: 'Austria', code: 'AT', dialCode: '+43', flag: '🇦🇹' },
  { name: 'İsveç', nameEn: 'Sweden', code: 'SE', dialCode: '+46', flag: '🇸🇪' },
  { name: 'Norveç', nameEn: 'Norway', code: 'NO', dialCode: '+47', flag: '🇳🇴' },
  { name: 'Danimarka', nameEn: 'Denmark', code: 'DK', dialCode: '+45', flag: '🇩🇰' },
  { name: 'Finlandiya', nameEn: 'Finland', code: 'FI', dialCode: '+358', flag: '🇫🇮' },
  { name: 'Polonya', nameEn: 'Poland', code: 'PL', dialCode: '+48', flag: '🇵🇱' },
  { name: 'Çek Cumhuriyeti', nameEn: 'Czech Republic', code: 'CZ', dialCode: '+420', flag: '🇨🇿' },
  { name: 'Yunanistan', nameEn: 'Greece', code: 'GR', dialCode: '+30', flag: '🇬🇷' },
  { name: 'Portekiz', nameEn: 'Portugal', code: 'PT', dialCode: '+351', flag: '🇵🇹' },
  { name: 'Rusya', nameEn: 'Russia', code: 'RU', dialCode: '+7', flag: '🇷🇺' },
  { name: 'Japonya', nameEn: 'Japan', code: 'JP', dialCode: '+81', flag: '🇯🇵' },
  { name: 'Çin', nameEn: 'China', code: 'CN', dialCode: '+86', flag: '🇨🇳' },
  { name: 'Güney Kore', nameEn: 'South Korea', code: 'KR', dialCode: '+82', flag: '🇰🇷' },
  { name: 'Hindistan', nameEn: 'India', code: 'IN', dialCode: '+91', flag: '🇮🇳' },
  { name: 'Brezilya', nameEn: 'Brazil', code: 'BR', dialCode: '+55', flag: '🇧🇷' },
  { name: 'Meksika', nameEn: 'Mexico', code: 'MX', dialCode: '+52', flag: '🇲🇽' },
  { name: 'Arjantin', nameEn: 'Argentina', code: 'AR', dialCode: '+54', flag: '🇦🇷' },
  { name: 'Kanada', nameEn: 'Canada', code: 'CA', dialCode: '+1', flag: '🇨🇦' },
  { name: 'Avustralya', nameEn: 'Australia', code: 'AU', dialCode: '+61', flag: '🇦🇺' },
  { name: 'Yeni Zelanda', nameEn: 'New Zealand', code: 'NZ', dialCode: '+64', flag: '🇳🇿' },
  { name: 'Güney Afrika', nameEn: 'South Africa', code: 'ZA', dialCode: '+27', flag: '🇿🇦' },
  { name: 'Mısır', nameEn: 'Egypt', code: 'EG', dialCode: '+20', flag: '🇪🇬' },
  { name: 'Suudi Arabistan', nameEn: 'Saudi Arabia', code: 'SA', dialCode: '+966', flag: '🇸🇦' },
  { name: 'Birleşik Arap Emirlikleri', nameEn: 'United Arab Emirates', code: 'AE', dialCode: '+971', flag: '🇦🇪' },
  { name: 'İsrail', nameEn: 'Israel', code: 'IL', dialCode: '+972', flag: '🇮🇱' },
  { name: 'İran', nameEn: 'Iran', code: 'IR', dialCode: '+98', flag: '🇮🇷' },
  { name: 'Irak', nameEn: 'Iraq', code: 'IQ', dialCode: '+964', flag: '🇮🇶' },
  { name: 'Suriye', nameEn: 'Syria', code: 'SY', dialCode: '+963', flag: '🇸🇾' },
  { name: 'Lübnan', nameEn: 'Lebanon', code: 'LB', dialCode: '+961', flag: '🇱🇧' },
  { name: 'Ürdün', nameEn: 'Jordan', code: 'JO', dialCode: '+962', flag: '🇯🇴' },
  { name: 'Kuveyt', nameEn: 'Kuwait', code: 'KW', dialCode: '+965', flag: '🇰🇼' },
  { name: 'Katar', nameEn: 'Qatar', code: 'QA', dialCode: '+974', flag: '🇶🇦' },
  { name: 'Bahreyn', nameEn: 'Bahrain', code: 'BH', dialCode: '+973', flag: '🇧🇭' },
  { name: 'Umman', nameEn: 'Oman', code: 'OM', dialCode: '+968', flag: '🇴🇲' },
  { name: 'Yemen', nameEn: 'Yemen', code: 'YE', dialCode: '+967', flag: '🇾🇪' },
  { name: 'Afganistan', nameEn: 'Afghanistan', code: 'AF', dialCode: '+93', flag: '🇦🇫' },
  { name: 'Pakistan', nameEn: 'Pakistan', code: 'PK', dialCode: '+92', flag: '🇵🇰' },
  { name: 'Bangladeş', nameEn: 'Bangladesh', code: 'BD', dialCode: '+880', flag: '🇧🇩' },
  { name: 'Sri Lanka', nameEn: 'Sri Lanka', code: 'LK', dialCode: '+94', flag: '🇱🇰' },
  { name: 'Tayland', nameEn: 'Thailand', code: 'TH', dialCode: '+66', flag: '🇹🇭' },
  { name: 'Vietnam', nameEn: 'Vietnam', code: 'VN', dialCode: '+84', flag: '🇻🇳' },
  { name: 'Endonezya', nameEn: 'Indonesia', code: 'ID', dialCode: '+62', flag: '🇮🇩' },
  { name: 'Malezya', nameEn: 'Malaysia', code: 'MY', dialCode: '+60', flag: '🇲🇾' },
  { name: 'Singapur', nameEn: 'Singapore', code: 'SG', dialCode: '+65', flag: '🇸🇬' },
  { name: 'Filipinler', nameEn: 'Philippines', code: 'PH', dialCode: '+63', flag: '🇵🇭' },
  { name: 'Tayvan', nameEn: 'Taiwan', code: 'TW', dialCode: '+886', flag: '🇹🇼' },
  { name: 'Hong Kong', nameEn: 'Hong Kong', code: 'HK', dialCode: '+852', flag: '🇭🇰' },
  { name: 'Macau', nameEn: 'Macau', code: 'MO', dialCode: '+853', flag: '🇲🇴' },
  { name: 'Nepal', nameEn: 'Nepal', code: 'NP', dialCode: '+977', flag: '🇳🇵' },
  { name: 'Myanmar', nameEn: 'Myanmar', code: 'MM', dialCode: '+95', flag: '🇲🇲' },
  { name: 'Kamboçya', nameEn: 'Cambodia', code: 'KH', dialCode: '+855', flag: '🇰🇭' },
  { name: 'Laos', nameEn: 'Laos', code: 'LA', dialCode: '+856', flag: '🇱🇦' },
  { name: 'Brunei', nameEn: 'Brunei', code: 'BN', dialCode: '+673', flag: '🇧🇳' },
  { name: 'Doğu Timor', nameEn: 'East Timor', code: 'TL', dialCode: '+670', flag: '🇹🇱' },
  { name: 'Mongolya', nameEn: 'Mongolia', code: 'MN', dialCode: '+976', flag: '🇲🇳' },
  { name: 'Kazakistan', nameEn: 'Kazakhstan', code: 'KZ', dialCode: '+7', flag: '🇰🇿' },
  { name: 'Özbekistan', nameEn: 'Uzbekistan', code: 'UZ', dialCode: '+998', flag: '🇺🇿' },
  { name: 'Kırgızistan', nameEn: 'Kyrgyzstan', code: 'KG', dialCode: '+996', flag: '🇰🇬' },
  { name: 'Tacikistan', nameEn: 'Tajikistan', code: 'TJ', dialCode: '+992', flag: '🇹🇯' },
  { name: 'Türkmenistan', nameEn: 'Turkmenistan', code: 'TM', dialCode: '+993', flag: '🇹🇲' },
  { name: 'Azerbaycan', nameEn: 'Azerbaijan', code: 'AZ', dialCode: '+994', flag: '🇦🇿' },
  { name: 'Ermenistan', nameEn: 'Armenia', code: 'AM', dialCode: '+374', flag: '🇦🇲' },
  { name: 'Gürcistan', nameEn: 'Georgia', code: 'GE', dialCode: '+995', flag: '🇬🇪' },
  { name: 'Ukrayna', nameEn: 'Ukraine', code: 'UA', dialCode: '+380', flag: '🇺🇦' },
  { name: 'Belarus', nameEn: 'Belarus', code: 'BY', dialCode: '+375', flag: '🇧🇾' },
  { name: 'Moldova', nameEn: 'Moldova', code: 'MD', dialCode: '+373', flag: '🇲🇩' },
  { name: 'Romanya', nameEn: 'Romania', code: 'RO', dialCode: '+40', flag: '🇷🇴' },
  { name: 'Bulgaristan', nameEn: 'Bulgaria', code: 'BG', dialCode: '+359', flag: '🇧🇬' },
  { name: 'Sırbistan', nameEn: 'Serbia', code: 'RS', dialCode: '+381', flag: '🇷🇸' },
  { name: 'Hırvatistan', nameEn: 'Croatia', code: 'HR', dialCode: '+385', flag: '🇭🇷' },
  { name: 'Slovenya', nameEn: 'Slovenia', code: 'SI', dialCode: '+386', flag: '🇸🇮' },
  { name: 'Slovakya', nameEn: 'Slovakia', code: 'SK', dialCode: '+421', flag: '🇸🇰' },
  { name: 'Macaristan', nameEn: 'Hungary', code: 'HU', dialCode: '+36', flag: '🇭🇺' },
  { name: 'Estonya', nameEn: 'Estonia', code: 'EE', dialCode: '+372', flag: '🇪🇪' },
  { name: 'Letonya', nameEn: 'Latvia', code: 'LV', dialCode: '+371', flag: '🇱🇻' },
  { name: 'Litvanya', nameEn: 'Lithuania', code: 'LT', dialCode: '+370', flag: '🇱🇹' },
  { name: 'İrlanda', nameEn: 'Ireland', code: 'IE', dialCode: '+353', flag: '🇮🇪' },
  { name: 'İzlanda', nameEn: 'Iceland', code: 'IS', dialCode: '+354', flag: '🇮🇸' },
  { name: 'Lüksemburg', nameEn: 'Luxembourg', code: 'LU', dialCode: '+352', flag: '🇱🇺' },
  { name: 'Malta', nameEn: 'Malta', code: 'MT', dialCode: '+356', flag: '🇲🇹' },
  { name: 'Kıbrıs', nameEn: 'Cyprus', code: 'CY', dialCode: '+357', flag: '🇨🇾' },
  { name: 'Şili', nameEn: 'Chile', code: 'CL', dialCode: '+56', flag: '🇨🇱' },
  { name: 'Kolombiya', nameEn: 'Colombia', code: 'CO', dialCode: '+57', flag: '🇨🇴' },
  { name: 'Peru', nameEn: 'Peru', code: 'PE', dialCode: '+51', flag: '🇵🇪' },
  { name: 'Venezuela', nameEn: 'Venezuela', code: 'VE', dialCode: '+58', flag: '🇻🇪' },
  { name: 'Ekvador', nameEn: 'Ecuador', code: 'EC', dialCode: '+593', flag: '🇪🇨' },
  { name: 'Bolivya', nameEn: 'Bolivia', code: 'BO', dialCode: '+591', flag: '🇧🇴' },
  { name: 'Paraguay', nameEn: 'Paraguay', code: 'PY', dialCode: '+595', flag: '🇵🇾' },
  { name: 'Uruguay', nameEn: 'Uruguay', code: 'UY', dialCode: '+598', flag: '🇺🇾' },
  { name: 'Fas', nameEn: 'Morocco', code: 'MA', dialCode: '+212', flag: '🇲🇦' },
  { name: 'Cezayir', nameEn: 'Algeria', code: 'DZ', dialCode: '+213', flag: '🇩🇿' },
  { name: 'Tunus', nameEn: 'Tunisia', code: 'TN', dialCode: '+216', flag: '🇹🇳' },
  { name: 'Libya', nameEn: 'Libya', code: 'LY', dialCode: '+218', flag: '🇱🇾' },
  { name: 'Sudan', nameEn: 'Sudan', code: 'SD', dialCode: '+249', flag: '🇸🇩' },
  { name: 'Etiyopya', nameEn: 'Ethiopia', code: 'ET', dialCode: '+251', flag: '🇪🇹' },
  { name: 'Kenya', nameEn: 'Kenya', code: 'KE', dialCode: '+254', flag: '🇰🇪' },
  { name: 'Tanzanya', nameEn: 'Tanzania', code: 'TZ', dialCode: '+255', flag: '🇹🇿' },
  { name: 'Uganda', nameEn: 'Uganda', code: 'UG', dialCode: '+256', flag: '🇺🇬' },
  { name: 'Gana', nameEn: 'Ghana', code: 'GH', dialCode: '+233', flag: '🇬🇭' },
  { name: 'Nijerya', nameEn: 'Nigeria', code: 'NG', dialCode: '+234', flag: '🇳🇬' },
  { name: 'Senegal', nameEn: 'Senegal', code: 'SN', dialCode: '+221', flag: '🇸🇳' },
  { name: 'Fildişi Sahili', nameEn: 'Ivory Coast', code: 'CI', dialCode: '+225', flag: '🇨🇮' },
  { name: 'Kamerun', nameEn: 'Cameroon', code: 'CM', dialCode: '+237', flag: '🇨🇲' },
  { name: 'Kongo Demokratik Cumhuriyeti', nameEn: 'DR Congo', code: 'CD', dialCode: '+243', flag: '🇨🇩' },
  { name: 'Angola', nameEn: 'Angola', code: 'AO', dialCode: '+244', flag: '🇦🇴' },
  { name: 'Mozambik', nameEn: 'Mozambique', code: 'MZ', dialCode: '+258', flag: '🇲🇿' },
  { name: 'Madagaskar', nameEn: 'Madagascar', code: 'MG', dialCode: '+261', flag: '🇲🇬' },
  { name: 'Mauritius', nameEn: 'Mauritius', code: 'MU', dialCode: '+230', flag: '🇲🇺' },
  { name: 'Seyşeller', nameEn: 'Seychelles', code: 'SC', dialCode: '+248', flag: '🇸🇨' },
  { name: 'Reunion', nameEn: 'Reunion', code: 'RE', dialCode: '+262', flag: '🇷🇪' },
  { name: 'Mayotte', nameEn: 'Mayotte', code: 'YT', dialCode: '+262', flag: '🇾🇹' },
  { name: 'Komorlar', nameEn: 'Comoros', code: 'KM', dialCode: '+269', flag: '🇰🇲' },
  { name: 'Cibuti', nameEn: 'Djibouti', code: 'DJ', dialCode: '+253', flag: '🇩🇯' },
  { name: 'Eritre', nameEn: 'Eritrea', code: 'ER', dialCode: '+291', flag: '🇪🇷' },
  { name: 'Somali', nameEn: 'Somalia', code: 'SO', dialCode: '+252', flag: '🇸🇴' },
  { name: 'Malavi', nameEn: 'Malawi', code: 'MW', dialCode: '+265', flag: '🇲🇼' },
  { name: 'Zambiya', nameEn: 'Zambia', code: 'ZM', dialCode: '+260', flag: '🇿🇲' },
  { name: 'Zimbabve', nameEn: 'Zimbabwe', code: 'ZW', dialCode: '+263', flag: '🇿🇼' },
  { name: 'Botsvana', nameEn: 'Botswana', code: 'BW', dialCode: '+267', flag: '🇧🇼' },
  { name: 'Namibya', nameEn: 'Namibia', code: 'NA', dialCode: '+264', flag: '🇳🇦' },
  { name: 'Lesotho', nameEn: 'Lesotho', code: 'LS', dialCode: '+266', flag: '🇱🇸' },
  { name: 'Svaziland', nameEn: 'Swaziland', code: 'SZ', dialCode: '+268', flag: '🇸🇿' },
  { name: 'Gine', nameEn: 'Guinea', code: 'GN', dialCode: '+224', flag: '🇬🇳' },
  { name: 'Sierra Leone', nameEn: 'Sierra Leone', code: 'SL', dialCode: '+232', flag: '🇸🇱' },
  { name: 'Liberya', nameEn: 'Liberia', code: 'LR', dialCode: '+231', flag: '🇱🇷' },
  { name: 'Gambiya', nameEn: 'Gambia', code: 'GM', dialCode: '+220', flag: '🇬🇲' },
  { name: 'Gine-Bissau', nameEn: 'Guinea-Bissau', code: 'GW', dialCode: '+245', flag: '🇬🇼' },
  { name: 'Yeşil Burun Adaları', nameEn: 'Cape Verde', code: 'CV', dialCode: '+238', flag: '🇨🇻' },
  { name: 'São Tomé ve Príncipe', nameEn: 'São Tomé and Príncipe', code: 'ST', dialCode: '+239', flag: '🇸🇹' },
  { name: 'Ekvator Ginesi', nameEn: 'Equatorial Guinea', code: 'GQ', dialCode: '+240', flag: '🇬🇶' },
  { name: 'Gabon', nameEn: 'Gabon', code: 'GA', dialCode: '+241', flag: '🇬🇦' },
  { name: 'Kongo Cumhuriyeti', nameEn: 'Republic of the Congo', code: 'CG', dialCode: '+242', flag: '🇨🇬' },
  { name: 'Orta Afrika Cumhuriyeti', nameEn: 'Central African Republic', code: 'CF', dialCode: '+236', flag: '🇨🇫' },
  { name: 'Çad', nameEn: 'Chad', code: 'TD', dialCode: '+235', flag: '🇹🇩' },
  { name: 'Nijer', nameEn: 'Niger', code: 'NE', dialCode: '+227', flag: '🇳🇪' },
  { name: 'Mali', nameEn: 'Mali', code: 'ML', dialCode: '+223', flag: '🇲🇱' },
  { name: 'Burkina Faso', nameEn: 'Burkina Faso', code: 'BF', dialCode: '+226', flag: '🇧🇫' },
  { name: 'Benin', nameEn: 'Benin', code: 'BJ', dialCode: '+229', flag: '🇧🇯' },
  { name: 'Togo', nameEn: 'Togo', code: 'TG', dialCode: '+228', flag: '🇹🇬' },
  { name: 'Ruanda', nameEn: 'Rwanda', code: 'RW', dialCode: '+250', flag: '🇷🇼' },
  { name: 'Burundi', nameEn: 'Burundi', code: 'BI', dialCode: '+257', flag: '🇧🇮' },
];

// Remove duplicates and sort by name
const uniqueCountries = countryCodes.filter((country, index, self) =>
  index === self.findIndex((c) => c.code === country.code)
);

export const sortedCountryCodes = uniqueCountries.sort((a, b) => a.name.localeCompare(b.name, 'tr'));

